import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import PieChart, {
    Series,
    Label,
    Connector,
    Tooltip,
    Export,
    Format,
    Margin,
    Legend,
    Size,
    SmallValuesGrouping,
} from 'devextreme-react/pie-chart';
import { locale, loadMessages } from "devextreme/localization";
import { Button } from 'devextreme-react/button';
import { FadingBalls } from 'react-cssfx-loading/lib';


locale(navigator.language || navigator.browserLanguage)



import { Animation, EventTracker } from '@devexpress/dx-react-chart';

export default function WasteStreams(props) {
    const classes = useStyles();
    const [rows, setRows] = useState([]);
    const [filter, setFilter] = useState(null);
    const [filterLevel, setFilterLevel] = useState(null);

    useEffect(() => {
        setRows(props.rows);
        setFilter(props.filter);
        setFilterLevel(props.filterLevel);

    }, [props.filter]);
    function customizeLabel(args) {
        if (props.filterLevel !== 2) {
            if (args.originalValue === 0) {
                const valueText = tonnageFormatter.format(args.originalValue);
                let html = `<div class="tonnage" style="font-size: 70%"> ${valueText} TON</div>`;
                return html;
            }else{
                const valueText = tonnageFormatter.format(args.originalValue);
                let html = `<div class="tonnage"> ${valueText} TON</div>`;
                return html;
            }
        } else {
            if (args.originalValue > 0) {
                const valueText = tonnageFormatter.format(args.originalValue);
                let html = `<div class="tonnage"> ${valueText} TON</div>`;
                return html;
            } else {
                return;
            }
        }

    }

    return (
        <div className={classes.wasteStreamContainer}>
            <Button className={classes.buttonContainer}
                text={"Terug"}
                icon="chevronleft"
                visible={filter !== null}
                onClick={props.onButtonClick}
            />
            <PieChart dataSource={props.rows} palette="Ocean" title={filter !== null ? filter : "Afvalfractie"} resolveLabelOverlapping="shift" onPointClick={props.onPointClick}>
                <Size height={550}/>
                <Legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="top" onPointClick={props.onPointClick} />
                <Margin top={20} bottom={20} left={30} right={30} />
                <Export enabled={true} />

                <Tooltip enabled={true} customizeTooltip={customizeTooltip}>
                    <Format type="fixedPoint" decimalSeparator="," precision={2} />
                </Tooltip>
                <Series
                    name={"Afvalfractie"}
                    valueField="quantity"
                    argumentField="material"
                    palette="Ocean"
                    paletteExtensionMode="blend"
                >
                    <Label visible={true} format="fixedPoint" customizeText={customizeLabel}>
                        <Format type="fixedPoint" precision={2} />
                        <Connector visible={true} width={1} />
                    </Label>

                </Series>
            </PieChart>
            {
                props.isLoading ?
                    <div className={classes.loadingNewData}>
                        <div className={classes.loadingContainer}>
                            <div className={classes.loadingCharts}>{"Grafiek laden"}</div>
                            <FadingBalls color="#1F8FA5" width="15px" height="15px"></FadingBalls>
                        </div>
                    </div>
                    : <React.Fragment></React.Fragment>
            }

        </div>
    )
}


const tonnageFormatter = new Intl.NumberFormat(
    'nl-BE', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
},
);

const customizeTooltip = (arg) => {
    const valueText = tonnageFormatter.format(arg.originalValue);
    return {
        text: `${arg.argument} - ${valueText} TON - ${(arg.percent * 100).toFixed(2)}%`,
    };
}


const useStyles = makeStyles(() => ({

    wasteStreamContainer: {
        position: 'relative',
        background: 'white',
        height: "550px",
        '& div > div > svg': {
            height: "500px",
            top: "-20px !important"
        },
        '& div': {
            maxHeight: "500px",
        }

    },
    buttonContainer: {
        textAlign: 'center',
        height: '40px',
        position: 'absolute',
        top: '28px',
        left: '5px',
    },
    titleComponent: {
        fontSize: "28px",
        fontFamily: "Segoe UI Light",
        width: "100%",
        textAlign: "center",
        marginTop: "15px"
    },
    labelComponent: {
        display: "flex",
        height: "25px",
        paddingTop: "7px"
    },

    labelText: {
        marginLeft: "5px",
        fontFamily: "Segoe UI,Helvetica Neue,Trebuchet MS,Verdana, sans-serif",
        fontSize: "12px",
        fontWeight: "400",
        color: "rgb(118,118,118)"
    },
    loadingNewData: {
        height: "100%",
        width: "100%",
        background: "white",
        position: "absolute",
        top: "0",
        opacity: '50%'
    },
    loadingContainer: {
        position: 'relative',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    }
}));